import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.9767 5.72375L10.9767 9.27628C10.9767 10.5263 10.4434 11.0263 9.11835 11.0263H5.88177C4.55677 11.0263 4.02344 10.5263 4.02344 9.27628L4.02344 5.72375C4.02344 4.47375 4.55677 3.97375 5.88177 3.97375H9.11835C10.4434 3.97375 10.9767 4.47375 10.9767 5.72375Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.9767 15.7238L10.9767 19.2763C10.9767 20.5263 10.4434 21.0263 9.11835 21.0263H5.88177C4.55677 21.0263 4.02344 20.5263 4.02344 19.2763L4.02344 15.7238C4.02344 14.4738 4.55677 13.9738 5.88177 13.9738H9.11835C10.4434 13.9738 10.9767 14.4738 10.9767 15.7238Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.9767 5.72375L20.9767 9.27628C20.9767 10.5263 20.4434 11.0263 19.1184 11.0263H15.8818C14.5568 11.0263 14.0234 10.5263 14.0234 9.27628L14.0234 5.72375C14.0234 4.47375 14.5568 3.97375 15.8818 3.97375H19.1184C20.4434 3.97375 20.9767 4.47375 20.9767 5.72375Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.9767 15.7238L20.9767 19.2763C20.9767 20.5263 20.4434 21.0263 19.1184 21.0263H15.8818C14.5568 21.0263 14.0234 20.5263 14.0234 19.2763L14.0234 15.7238C14.0234 14.4738 14.5568 13.9738 15.8818 13.9738H19.1184C20.4434 13.9738 20.9767 14.4738 20.9767 15.7238Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }